<div class="field-checkbox-wrapper">

  <div class="checkbox-option" *ngFor="let ans of parsedAnswers">
    <label class="checkbox-label">
      <input type="checkbox" [(ngModel)]="ans.isChecked" [disabled]="!isInput" (ngModelChange)="onChange($event)">
      <span class="option-text">&nbsp;{{ans.option}}</span>
    </label>
  </div>

</div>